import React, { useEffect, useState } from 'react';
import upimg from "../../../images/upload.png";
import pro from "../../../images/profile-img.png";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { profileget, update_profile } from '../../../redux/authslice';
import profileimg from "../../../images/profile-main.jpg";

function Userdetail() {

  const dispatch = useDispatch();
  const { profiledata } = useSelector((state) => state.counter)
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    school_year: '',
    user_image: ""
  });
  const [imageURL, setImageURL] = useState("");
  const [errors, setErrors] = useState({});
  const [isModified, setIsModified] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }

    setIsModified(true);
  };

  const handleFileChange = (files) => {
    const acceptedFileTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', ""];

    if (!files || files?.length === 0) {
      setFormData({
        ...formData,
        user_image: ""
      });
      return;
    } else {
      const file = files[0];
      if (!acceptedFileTypes.includes(file?.type)) {
        toast.error("Invalid file type. Please upload a PNG, JPEG, or GIF file.");
        return;
      }

      setFormData({
        ...formData,
        user_image: file
      });
      setIsModified(true);
      const url = URL.createObjectURL(file);
      setImageURL(url);
    }
  };

  const validate = () => {
    let errors = {};
    if (!formData.first_name) errors.first_name = 'First name required';
    if (!formData.last_name) errors.last_name = 'Last name required';
    if (!formData.email) {
      errors.email = 'Email required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email address invalid';
    }
    if (!formData.school_year) errors.school_year = 'School year required';
    return errors;
  };

  const handleSave = () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors)?.length > 0) {
      setErrors(validationErrors);
      return;
    }

    dispatch(update_profile({ formData, dispatch }));
    setIsModified(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    handleFileChange(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    dispatch(profileget(dispatch))
  }, [dispatch])

  useEffect(() => {
    if (profiledata) {
      setFormData({
        ...formData,
        first_name: profiledata?.first_name,
        last_name: profiledata?.last_name,
        email: profiledata?.email,
        school_year: profiledata?.school_year,
        user_image: profiledata?.user_image
      });
    }
  }, [profiledata]);

  return (
    <>
      {/* -----------------Profile Photo-------------------------- */}
      <section className="all-dasboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="profile-img-box">
                <div className="row">
                  <div className="col-lg-4">
                    <p className="pro-head">Profile photo</p>
                    <p className="pro-sub-head">
                      This image will be displayed on your profile photo
                    </p>
                  </div>
                  <div className="col-lg-8">
                    <div className="pofile-img-box1">
                      <div className="profile-imgs">
                        {formData?.user_image ? (
                          imageURL ? (
                            <img src={imageURL} alt="Uploaded" />
                          ) : (
                            <img
                              // src={`https://quizapi.trickywebsolutions.com${formData.user_image}`}
                              src={formData.user_image}

                              alt="..." />
                          )
                        ) : (
                          <img src={profileimg} alt="Default" />
                        )}


                      </div>
                      <div className="drag-drop" onDrop={handleDrop} onDragOver={handleDragOver}>
                        <label htmlFor="file-input" style={{ cursor: 'pointer' }}>
                          <img src={upimg} alt="Upload Icon" />
                        </label>
                        <input
                          id="file-input"
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) => handleFileChange(e.target.files)}
                          accept="image/jpeg, image/jpg, image/png, image/gif"
                        />
                        <p className="drag-drop-head1">
                          Click to update or drag and drop
                        </p>
                        <p className="drag-drop-head2">
                          JPG, PNG, or GIF (recommended size 1000 x 1000)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* -----------------Personal Information -------------------- */}
      <section className="all-dasboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="profile-img-box">
                <div className="row">
                  <div className="col-lg-4">
                    <p className="pro-head">Personal information</p>
                    <p className="pro-sub-head">
                      Update your personal information here
                    </p>
                  </div>
                  <div className="col-lg-8">
                    <div className="pofile-form-box">
                      <form>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label htmlFor="first_name" className="input-box-head">
                                First name
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                                id="first_name"
                                name="first_name"
                                required=""
                                placeholder="Enter first name"
                                value={formData.first_name}
                                onChange={handleChange}
                              />
                              {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label htmlFor="last_name" className="input-box-head">
                                Last name
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                                id="last_name"
                                name="last_name"
                                required=""
                                placeholder="Enter last name"
                                value={formData.last_name}
                                onChange={handleChange}
                              />
                              {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="email" className="input-box-head">
                            Email address
                          </label>
                          <input
                            type="email"
                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                            id="email"
                            name="email"
                            required=""
                            placeholder="Enter email address"
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="school_year" className="input-box-head">
                            School year
                          </label>
                          <select
                            className={`form-control ${errors.school_year ? 'is-invalid' : ''}`}
                            name="school_year"
                            value={formData.school_year}
                            onChange={handleChange}
                          >
                            <option value="Year_7">Year 7</option>
                            <option value="Year_8">Year 8</option>
                            <option value="Year_9">Year 9</option>
                            <option value="Year_10">Year 10</option>
                            <option value="Year_11">Year 11</option>
                            <option value="Year_12">Year 12</option>
                            <option value="Year_13">Year 13</option>
                          </select>
                          {errors.school_year && <div className="invalid-feedback">{errors.school_year}</div>}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="save">
              <button className="btn-save" onClick={handleSave} disabled={!isModified}>Save</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Userdetail
